document.addEventListener('DOMContentLoaded', function () {
    // The switch-currency section is not rendered on every template (e.g. the
    // PageFly layout), so bail out when its modal is absent rather than calling
    // addEventListener on a null selector (F7b).
    if (!document.querySelector('.currency-switch-modal')) {
        return;
    }

    let count = 0;

    const intervalShowModal = setInterval(() => {
        if (window.CozyCountryRedirectLoaded) {
            const modal = document.querySelector('.currency-switch-modal');
            const modal_currency = document.querySelector('.currency-modal');

            const isShow = localStorage.getItem('currency-switch-modal');

            const country = CozyCountryRedirect.country;

            if (!isShow && country) {
                let regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
                const countryUpperCase = country.toUpperCase();
                const countryName = regionNames.of(Shopify.country);

                if (window.country_code != countryUpperCase) {
                    modal.querySelector('.country-name').textContent = modal.querySelector('.country-name').textContent.replace('[[country]]', countryName);

                    modal.style.display = 'block';

                    modal.querySelector('.open-switch').addEventListener('click', function () {
                        modal_currency.style.display = 'block';
                        modal.style.display = 'none';
                    });

                    localStorage.setItem('currency-switch-modal', true);
                }
            }

            clearInterval(intervalShowModal);
        } else {
            count++;
        }

        if (count > 50) {
            clearInterval(intervalShowModal);
        }

    }, 200);


    document.querySelectorAll('.close-modal').forEach(x => {
        x.addEventListener('click', function () {
            document.querySelector('.currency-switch-modal').style.display = 'none';
            document.querySelector('.currency-modal').style.display = 'none';
        })
    });

    document.querySelector('.currency-switch-modal-bottom button').addEventListener('click', function () {
        document.querySelector('.currency-switch-modal').style.display = 'none';
        document.querySelector('.currency-modal').style.display = 'none';
    })
})
